/**
 * @file 页面配置需要的常量
 * @author caixiaowen
 */

const postStateMap = {
    OP_PENDING: '待解决',
    OP_PROCESSING: '处理中',
    OP_SOLVED: '已解决'
};

const issueBugProcessOptions = [
    {
        label: postStateMap.OP_PENDING,
        value: 'OP_PENDING'
    },
    {
        label: postStateMap.OP_PROCESSING,
        value: 'OP_PROCESSING'
    },
    {
        label: postStateMap.OP_SOLVED,
        value: 'OP_SOLVED'
    }
];

const detailCommonTxt
    = `<p>====================</p>
    <p>问题描述：</p>
    <p>问题分析：</p>
    <p>问题当前状态：</p>
    <p>问题影响面：</p>
    <p>监控未及时发现原因：</p>
    <p>问题TODO：</p>`;
const RealMachineDetail
    = `<p>【真机问题收集模板】</p>
    <p>000.【必填】是否线上问题</p>
    <p>00.【必填】高优处理说明（用于评估问题优先级；从重要性，严重性，影响面等方面进行说明）</p>
    <p>0.【必填】是否必现</p>
    <p>1.【必须】iOS手百可复现版本（我的->设置->关于我们->关于）</p>
    <p>1.【必须】Android手百可复现版本（我的->设置->关于我们->关于）</p>
    <p>2.【必须】手机机型&系统版本</p>
    <p>3.【必须】基础库版本枚举（swan-core版本，查看方法：任意小程序右上角点击...->关于->快速点击5次小程序icon，技术支持要确认4+个swanjs版本是否可复现）</p>
    <p>4.【必须】二维码</p>
    <p>5.【必须】复现步骤 （复杂问题、不好描述的问题请提供录屏并说明在第几秒处）</p>
    <p>6.【必须】提供代码片段/源代码（工具问题反馈渠道）</p>
    ${detailCommonTxt}`;
const DocsDetail
    = `<p>【文档】</p>
    <p>1.【必须】提供文档链接</p>
    <p>2.【必须】提供文档截图</p>
    ${detailCommonTxt}`;
const TripartiteDetail
    = `<p>【第三方写法】</p>
    <p>1.【必须】代码demo</p>
    <p>2.【必须】三方框架编译后代码</p>
    <p>3.【必须】复现路径或报错截图</p>
    <p>4.【常见问题】如果run不起来的问题，请详细检查下依赖按照步骤，或者提供截图，配合技术对接安装复现下</p>
    ${detailCommonTxt}`;
const ToolDetail
    = `<p>【工具】</p>
    <p>1.【必须】操作系统</p>
    <p>2.【必须】编译工具版本</p>
    <p>3.【必选】开发者工具版本</p>
    <p>4.【必选】基础库版本</p>
    <p>5.【必选】出现问题或者报错的代码片段</p>
    ${detailCommonTxt}`;
const OfficialBoardLabel = {
    QuestionCategory: {
        label: '确认问题状态',
        tip: '可将非技术类问题转给客服同学处理'
    },
    QuestionType: {
        label: '确认问题类型',
        tip: '请根据开发者提供的内容复现问题，并进行分类'
    },
    QuestionDetail: {
        label: '复现路径',
        text: {
            1: RealMachineDetail,
            2: RealMachineDetail,
            3: RealMachineDetail,
            4: ToolDetail,
            5: RealMachineDetail,
            6: RealMachineDetail,
            7: RealMachineDetail,
            8: DocsDetail,
            9: TripartiteDetail,
            10: detailCommonTxt
        }
    },
    BugLevel: {
        label: '问题定级',
        tip: `bug定级说明：<br>
            bug定级标准参见<a target="_blank" href="http://wiki.baidu.com/pages/viewpage.action?pageId=906423242">
                http://wiki.baidu.com/pages/viewpage.action?pageId=906423242</a>
            <br>定级查询工具：<a target="_blank" href="http://swangray.baidu-int.com/#/swanjs/p0p1grading">
                http://swangray.baidu-int.com/#/swanjs/p0p1grading</a>`
    },
    QuestionTag: {
        label: '问题标签'
    },
    AnswerContent: {
        label: '具体内容',
        placeholder: {
            1: '<p id="placeholder" style="color:#999;">请在回复中包含问题原因、规避方案、预计修复时间、issue链接等信息</p>',
            2: '<p id="placeholder" style="color:#999;">您的问题经定位后发现为xx功能暂不支持，我们将排期开发，具体进展详见issue</p>',
            3: '<p id="placeholder" style="color:#999;">请在回复中包含开发者具体的使用错误、相关问题排查方法及正确使用方式等内容</p>'
        }
    },
    AuditStaff: {
        label: '审核人员'
    },
    DutyStaff: {
        label: '跟进人'
    },
    IcafeLink: {
        label: 'iCafe链接'
    },
    OfficialProcess: {
        label: '处理状态'
    },
    RelatedIssue: {
        label: '关联issue'
    }
};

const clearDeTailTip
    = `还原问题标签对应的复现路径模板or清空已填写内容，请点击这里。
        点击后已填写内容不会保存`;

const questionCategory = [
    {
        label: '已确认问题',
        value: 1
    },
    {
        label: '信息缺失',
        value: 2
    },
    {
        label: '不能复现',
        value: 3
    }
];

const questionType = [
    {
        label: 'bug',
        value: 1
    },
    {
        label: '需求',
        value: 2
    },
    {
        label: 'Not a bug',
        value: 3
    }
];

const bugLevel = [
    {
        label: 'p0',
        value: 0
    },
    {
        label: 'p1',
        value: 1
    },
    {
        label: 'p2',
        value: 2
    },
    {
        label: 'p3',
        value: 3
    }
];

const questionTag = [
    {
        label: '组件',
        value: 1
    },
    {
        label: 'api',
        value: 2
    },
    {
        label: '框架',
        value: 3
    },
    {
        label: '开发者工具',
        value: 4
    },
    {
        label: '双端',
        value: 5
    },
    {
        label: 'iOs',
        value: 6
    },
    {
        label: '安卓',
        value: 7
    },
    {
        label: '文档',
        value: 8
    },
    {
        label: '三方写法问题',
        value: 9
    },
    {
        label: '非技术问题',
        value: 10
    }
];

const showTips = {
    lackFollowUser: '请先分配跟进人员，再进行此操作',
    missInfoParams: '您的信息不够完善，无法提交，请重新操作',
    notRelatedIssue: '已关联issue会被清空，确认操作吗？',
    withoutSaveCategory: '您的问题分类有改动，请先设置再进行提交，点击确认不会保存您的修改',
    withoutSetIssue: '尚未设置关联Issue，请先设置再进行提交',
    withoutSaveRely: '您的回复内容未保存，请先保存再进行提交，点击确认不会保存您的修改',
    withoutChooseAudit: '尚未指定审核人员，请先设置再进行提交',
    withoutAuditRejectDesc: '请填写审核拒绝原因',
    officialOperationLost: '权限已过期，请联系相关管理员进行修改',
    maxRelatedIssue: 10,
    moreRelatedIssue: '您关联的帖子已超出10条，请重新选择'
};

const relatedTypeMap = {
    issue: '相关问题与需求',
    link: '相关链接',
    topic: '相关问题'
};

const extMaxStrLen = 50;

const SelectOptions = {
    OfficialBoardLabel,
    questionCategory,
    // questionType,
    bugLevel,
    questionTag,
    showTips,
    relatedTypeMap,
    clearDeTailTip,
    extMaxStrLen,
    postStateMap,
    issueBugProcessOptions
};
export default SelectOptions;
